<template>
  <v-row class="pb-6">
    <v-col cols="12">
      <BaseDataTable
        :headers="header"
        :items="list"
        :search="filter"
        no-data-text="Nenhum Tomador foi encontrado"
        loading-text="Carregando Tomadores..."
        :loading="loading"
      >
        <template v-slot:[`item.nome_fantasia`]="{ item }">
          <div class="quotation-table-click" @click="selectedItem(item)">
            {{ item.nome_fantasia }}
          </div>
        </template>
        <template v-slot:[`item.cnpj`]="{ item }">
          <div class="quotation-table-click" @click="selectedItem(item)">
            <input-facade
              :mask="maskCNPJ"
              :value="item.cnpj"
              disabled
              class="subtitle-2 gray--text quotation-table-click"
            />
          </div>
        </template>
        <template v-slot:[`item.subsidiaria`]="{ item }">
          {{ types[item.subsidiaria] }}
        </template>
        <template v-slot:[`item.favorito`]="{ item }">
          <v-btn text icon @click="updateFavoriteTable(item)">
            <v-avatar size="16">
              <v-icon color="yellow" size="16">
                {{ getIcon(item) }}
              </v-icon>
            </v-avatar>
          </v-btn>
        </template>
      </BaseDataTable>
    </v-col>
  </v-row>
</template>
<script>
const tableHeaders = [
  { text: "Tomadores", value: "nome_fantasia", sortable: true },
  { text: "CNPJ", value: "cnpj", sortable: true },
  { text: "Matriz ou Filial", value: "subsidiaria", sortable: true },
  { text: "Favoritos", value: "favorito", sortable: false }
];
import { PayloadCompany } from "@/mixins/PayloadCompanyMixin";
import { maskCNPJ } from "@/utils/masks.js";
export default {
  data() {
    return {
      header: tableHeaders,
      maskCNPJ,
      types: { false: "MATRIZ", true: "FILIAL" }
    };
  },
  mixins: [PayloadCompany],
  methods: {
    updateFavoriteTable(item) {
      this.$emit(
        "favorite",
        this.getFavoriteCompanyPayload(this.value.id, item, item.favorito)
      );
    },
    selectedItem(item) {
      this.$emit("selected", this.getPayload(item));
    },
    getIcon(item) {
      return item.favorito ? "fa-star" : "far fa-star";
    },
    getPayload(item) {
      return {
        economicGroup: this.value,
        taker: item
      };
    }
  },
  props: {
    filter: {
      type: String
    },
    list: {
      type: Array
    },
    loading: {
      type: Boolean
    },
    value: {
      type: Object
    }
  }
};
</script>
<style lang="sass"></style>
